function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#979797",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 0h1v5H3zM16 0h1v5h-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 3.583C20 2.71 19.293 2 18.42 2H1.579c-.422 0-.827.167-1.126.464-.294.298-.456.7-.453 1.12v15.833C0 20.29.707 21 1.58 21h16.842c.422 0 .827-.167 1.126-.464.294-.298.456-.7.453-1.12V3.584zM18.83 19.786a.515.515 0 0 1-.378.158H1.579a.527.527 0 0 1-.526-.527V3.583c-.001-.137.052-.27.147-.37a.515.515 0 0 1 .347-.157H18.39c.291 0 .527.236.527.527V19.417a.529.529 0 0 1-.085.37z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 8h19v1H0z"
}));

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.cfc3ca72.svg";
export { ForwardRef as ReactComponent };